/**
 * Predictive Search Initial Content
 * Håndterer initial content visning ("Favoritter lige nu")
 */

class PredictiveSearchInitialContent {
  constructor(container) {
    this.container = container;
    this.isVisible = false;
  }

  /**
   * Viser initial content når input er tomt
   */
  show() {
    if (!this.container) return;
    this.container.hidden = false;
    this.isVisible = true;
    
    // Remove "Se detaljer" buttons from initial content
    const viewButtons = this.container.querySelectorAll('.quick-add-view-btn, a.btn--secondary, a[href*="/products/"].btn--secondary');
    viewButtons.forEach(function(btn) {
      btn.remove(); // Completely remove from DOM
    });
  }

  /**
   * Skjuler initial content når der er søgeterm
   */
  hide() {
    if (!this.container) return;
    this.container.hidden = true;
    this.isVisible = false;
  }

  /**
   * Tjekker om initial content skal vises baseret på input værdi
   */
  toggle(inputValue) {
    if (!inputValue || inputValue.trim().length === 0) {
      this.show();
    } else {
      this.hide();
    }
  }
}

// Export for use in other files
if (typeof module !== 'undefined' && module.exports) {
  module.exports = PredictiveSearchInitialContent;
}

// Make available globally (only if not already defined to prevent re-declaration errors)
if (typeof window !== 'undefined' && !window.PredictiveSearchInitialContent) {
  window.PredictiveSearchInitialContent = PredictiveSearchInitialContent;
}

